import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import MarketTicker from "@/components/MarketTicker";
import Hero from "@/components/Hero";
import LiveMarketsPanel from "@/components/LiveMarketsPanel";
import ChallengesSection from "@/components/ChallengesSection";
import StatsCounters from "@/components/StatsCounters";
import FeaturedIn from "@/components/FeaturedIn";
import UGCSection from "@/components/UGCSection";
import ScrollProgress from "@/components/ScrollProgress";
import HeroStatStrip from "@/components/HeroStatStrip";
import CTABanner from "@/components/CTABanner";
import FaqJsonLd from "@/components/FaqJsonLd";
import PlatformShowcase from "@/components/PlatformShowcase";
import EvaluationProcess from "@/components/EvaluationProcess";
import SocialProofToast from "@/components/SocialProofToast";

/* Leaner home page — visitors land, see the value prop + pricing + social
   proof + CTA. Deep content (evaluation process, reviews, FAQ, profit
   calculator, why OFunded, payouts, partner program, contact) lives on
   dedicated pages for SEO and clarity. */
export default function HomePage() {
  return (
    <div data-testid="home-page" className="relative overflow-x-hidden">
      <FaqJsonLd />
      <ScrollProgress />
      <SocialProofToast />
      <Navbar />

      <div id="hero" />
      <Hero />

      {/* Quick trust numbers before they scroll past */}
      <HeroStatStrip />

      {/* Conversion-first: the buy decision is the next thing visitors see */}
      <ChallengesSection />

      {/* "Get Funded in 3 Steps" — the floor that explains the journey,
          placed right after the buy decision so visitors instantly see
          how the funded path works before browsing platforms. */}
      <EvaluationProcess />

      {/* "What you'll trade on" — Platforms are part of the buy decision,
          so they get higher priority than the LiveMarkets discovery panel. */}
      <PlatformShowcase />

      <StatsCounters />

      <UGCSection />

      <FeaturedIn />

      <MarketTicker />

      <section id="markets" data-testid="hero-chart-section" className="relative">
        <LiveMarketsPanel />
      </section>

      <CTABanner />
      <Footer />
    </div>
  );
}
